// extracted by mini-css-extract-plugin
module.exports = {"container":"BluredJobs_container__1SrHR","blured-container":"BluredJobs_blured-container__3oxE4","box":"BluredJobs_box__1y2j8","box-buttons":"BluredJobs_box-buttons__3Ubuu"};